/**
 * In-app messages (DEV-443) — the retained snapshot topic of app `sl2`.
 * Spec `dev/projects/in-app-messages.md` R1. Only the mbls-admin Lambda publishes here;
 * the SL2 IoT authorizer grants subscribe + receive on it, never publish.
 */
export const InAppMessagesTopic = "mrt/platform/messages/sl2";
